
		import App from './src/App.js';
		let app = new App();
		window.app = app; // add global access in html
	